import { IconButton, Menu, MenuItem } from "@mui/material";
import { withStyles } from '@mui/styles';
import { Component, default as React } from "react";
import { Icon, Text } from "./index";
import { NavLink } from "react-router-dom";
import { mdiDotsVertical, mdiUnfoldMoreVertical } from "@mdi/js";
import * as Util from "../infra/Util.js";
/*
  {
    to: `/${filial._id}/editar`,
    text: "Editar",
    componente:<Componennte>
    onClick: () => {
    },
  }
*/
class PopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: [],
    };
  }

  button(item, i, index) {

    return (
      <MenuItem
        key={i}
        onClick={() => {
          if (item.onClick) {
            item.onClick();
          }
          if (item.close) {
            let anchorEl = Util.clone(this.state.anchorEl)
            anchorEl[index] = false;
            this.setState({ anchorEl })
          }
        }}>
        {item.text}
      </MenuItem>
    )
  }

  render() {
    var { text, color = 'black', index, lista = [] } = this.props;
    return (
      <div key={"action" + index}>
        <IconButton
          aria-label="More"
          aria-owns={this.state.anchorEl[index] ? 'long-menu' : null}
          aria-haspopup="true"
          style={{ minHeight: 45, minWidth: 45, justifyContent: 'center', flexDirection: 'row' }}
          onClick={(event) => {
            let anchorEl = this.state.anchorEl
            anchorEl[index] = event.currentTarget
            this.setState({ anchorEl })
          }}
        >
          {text && <Text style={{ color }}>{text}</Text>}
          <Icon size={1} color={color} path={mdiDotsVertical} />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={this.state.anchorEl[index]}
          open={Boolean(this.state.anchorEl[index])}
          onClose={() => {
            let anchorEl = this.state.anchorEl
            anchorEl[index] = null;
            this.setState({ anchorEl })
          }}
        >
          {lista.map((item, i) => {
            if (item.to) {
              return (
                <NavLink to={item.to}>
                  {this.button(item, i, index)}
                </NavLink>
              )
            } if (item.component) {
              return (
                item.component
              )
            } else {
              return (this.button(item, i, index))
            }
          })}
        </Menu>
      </div >
    )
  }
}

var styles = {
};
const styl = theme => ({
});
export default withStyles(styl)(PopMenu);
